export class ProfessionVerificationModel {
    LicenseNumber: string;
    LicenseType: string;
    LicenseAuthroityName: string;
    LicenseAuthorityPhone: string;
    IssuedDate: any;
    ExpirationDate: any;
    StateIssued: any;
    Status: boolean;
    OrderId: string;
    EntryInWhichCase: string;
    Id: string;

}

